import {request} from "../../../utils/request/index.js";
const defaultUploadFn = (params) => {
  const fd = new FormData();
  fd.append("image", params.file);
  request.post("/saas/product/v1/images", fd, {
    onUploadProgress: (event) => {
      params.progress(event.loaded / event.total * 100);
    }
  }).then((data) => {
    params.success({
      url: data,
      meta: {
        id: params.libraryId,
        title: params.file.name,
        alt: params.file.name,
        loop: false,
        autoPlay: false,
        controls: false,
        poster: ""
      }
    });
  }).catch((error) => {
    params.error({msg: error.message});
  });
};
export default defaultUploadFn;
